var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.25,
    height: 20,
    viewBox: "0 0 20.25 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3307",
    "data-name": "Rectangle 3307",
    width: 9.77,
    height: 12.36,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11881",
    "data-name": "Group 11881",
    transform: "translate(-214 -389.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10162",
    "data-name": "Group 10162",
    transform: "translate(-79 105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10159",
    "data-name": "Group 10159",
    transform: "translate(-6388 -407.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10055",
    "data-name": "Group 10055",
    transform: "translate(6681 692)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2970",
    "data-name": "Rectangle 2970",
    width: 20.25,
    height: 20,
    rx: 10,
    fill: "#4a90f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11879",
    "data-name": "Group 11879",
    transform: "translate(219.24 393.32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11876",
    "data-name": "Group 11876",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10111",
    "data-name": "Path 10111",
    d: "M.731,3.674H.006C0,3.634,0,3.6,0,3.562c0-.412,0-.824,0-1.236a.823.823,0,0,1,.877-.872H2.5V1.336c0-.314,0-.628,0-.942A.373.373,0,0,1,2.893,0H6.9a.381.381,0,0,1,.373.388c0,.311,0,.621,0,.932,0,.04,0,.08,0,.134H8.892a.828.828,0,0,1,.877.874c0,.412,0,.824,0,1.236v.109H9.043V3.8q0,3.848,0,7.7a.825.825,0,0,1-.362.717.863.863,0,0,1-.517.144h-3.3q-1.646,0-3.291,0a.8.8,0,0,1-.8-.567,1.034,1.034,0,0,1-.039-.3q0-3.818,0-7.636V3.674m7.539.005c-.04,0-.069-.005-.1-.005q-3.286,0-6.571,0c-.086,0-.107.026-.107.109q0,3.827,0,7.654c0,.157,0,.157.156.157h6.46c.158,0,.158,0,.158-.154q0-3.822,0-7.644ZM.938,2.218a.328.328,0,0,0-.1,0c-.024.008-.059.036-.059.055,0,.208,0,.416,0,.625H9c0-.18,0-.348,0-.516s0-.17-.169-.17M3.271,1.446a.261.261,0,0,0,.044.008l3.118,0c.061,0,.073-.027.072-.08,0-.169-.006-.338,0-.506C6.51.783,6.48.763,6.4.763q-1.508,0-3.017,0c-.036,0-.071,0-.109.005Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3304",
    "data-name": "Rectangle 3304",
    width: 0.759,
    height: 6.321,
    transform: "translate(2.729 4.584)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3305",
    "data-name": "Rectangle 3305",
    width: 0.761,
    height: 6.318,
    transform: "translate(4.511 4.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3306",
    "data-name": "Rectangle 3306",
    width: 0.759,
    height: 6.322,
    transform: "translate(6.291 4.581)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpDelete);
export default __webpack_public_path__ + "static/media/op-delete.5372f07d8198132f034f353d6f6ba5be.svg";
export { ForwardRef as ReactComponent };